import InvoiceData from './InvoiceData';
import InvoiceHead from './InvoiceHead';
import InvoiceItems from './InvoiceItems';
import Totals from './Totals';

export default function InvoiceContent({ invoice }) {
  return (
    <div className="invoices__paper__padding">
      <InvoiceHead invoice={invoice} />
      <InvoiceData invoice={invoice} />
      <InvoiceItems invoice={invoice} />
      <Totals invoice={invoice} />
    </div>
  );
}
